import React from "react";
import ImageTag from "../components/reuseable/imageTag";
import FormSection from "../components/signup-section/form.jsx";

function Signup() {
  return (
    <div className="lg:h-screen flex items-center ">
      <div className="flex w-full lg:h-screen rounded-xl">
        <div className="w-[50%] h-full hidden lg:flex items-center justify-center bg-gradient-to-b from-[#0f172a] to-[#1E293B] shadow-md rounded-tr-3xl rounded-br-3xl">
          <ImageTag
            path="/assets/logo.png"
            classes="w-[80%] h-[140px] object-contain"
            altText="login"
          />
        </div>
        <div className=" w-full lg:w-[50%] h-full  my-auto flex flex-col items-center justify-center bg-white py-[20px]">
          <div className="w-[90%] lg:w-[80%] mx-auto flex flex-col items-center justify-center h-full  overflow-y-scroll">
            <div className=" bg-gradient-to-b from-[#0f172a] to-[#1E293B] shadow-md lg:hidden flex justify-center items-center rounded-xl px-2  py-12 w-[100%] mb-[10px] ">
              <ImageTag
                path="/assets/logo.png"
                classes="w-[80%] h-[120px] object-contain "
                altText="logo"
              />
            </div>
            <div className="w-full pt-8 flex flex-col justify-center">
              <h1 className="text-fontColor font-semibold  text-2xl 2xl:text-3xl">
                Sign Up
              </h1>
              <p className="text-fontColor text-xs pt-1 font-medium mb-4 text-[12px]">
                Welcome! , Please put your login credentials below to start
                using the dashboard.
              </p>

              <FormSection />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Signup;
